import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../../../useApiQuery';

const useGetMarketplaceHostProfile = ({
  showId: showIdParam,
  profileId: profileIdParam,
  disabled,
  shouldRefetch = () => false,
} = {}) => {
  const { showId: currentShowId, profileId: currentProfileId } = useParams();
  const showId = showIdParam || currentShowId;
  const profileId = profileIdParam || currentProfileId;

  const query = useApiQuery({
    queryKey: keys.hostProfile({ showId, profileId }),
    requestUrl: `/shows/${showId}/marketplace/profiles/hosts/${profileId}`,
    disabled: disabled || !profileId || !showId,
    refetchInterval: (profile) => (shouldRefetch(profile) ? 5000 : false),
    refetchOnMount: (profile) => (shouldRefetch(profile) ? 5000 : false),
  });

  return {
    hostProfile: query.data,
    hostProfileError: query.error,
    isHostProfileFetchError: query.isError,
    isHostProfileFetchSuccess: query.isSuccess,
    isHostProfileFetching: query.isFetching,
    isHostProfileLoading: query.isInitialLoading,
    refetchHostProfile: query.refetch,
    ...query,
  };
};

export default useGetMarketplaceHostProfile;
